<template>
  <!-- 弹框  旧年份书籍 -->
  <van-overlay :show="show" z-index="999" duration="0.05">
    <div class="container">
      <header>
        <!-- <router-link>跳过</router-link> -->
        <div class="a" @click="toJump">跳过</div>
      </header>
      <div class="main">
        <div class="headline">
          <div class="headline_top">Hi，欢迎加入会员</div>
          <div class="headline_bottom">以下为您最近浏览过的书，加入书架后使用更方便～</div>
        </div>
        <div class="contant">
          <van-checkbox-group v-model="result" @change="change">
            <div v-for="(item, index) in bookData" :key="index">
              <van-checkbox
                class="book"
                :name="item[0].toString()"
                :class="{ noright: (index + 1) % 3 == 0 }"
              >
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
                <div>
                  <!-- <img :src="`/cms/upload/cover/p` + item[1]" /> -->
                  <img v-lazy="lazyImage(item[1]) || {}" />
                </div>
              </van-checkbox>
            </div>
          </van-checkbox-group>
          <button :class="noAdd ? 'gray' : ''" @click="toAddBook">好，加入书架！</button>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { register } from '@/plugin/popup'
import { getformData, setCookie } from '@/static/js/zjs.js'
import { Checkbox, CheckboxGroup, Toast } from 'vant'
export default {
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Toast.name]: Toast
  },
  data() {
    return {
      show: false,
      bookData: [],
      checked: true,
      userInfo: this.$store.userInfo || {},
      result: [],
      noAdd: false,
      activeIcon: 'https://img.yzcdn.cn/upload_files/2020/04/30/FhDxYgRMzvTaDOrtMsvO6BkpAZgl.png',
      inactiveIcon: 'https://img.yzcdn.cn/upload_files/2020/05/07/FgRpClRfR3wxbQcVy5TePbTDFgUq.png',
      loading: false
    }
  },
  mounted() {
    // this.getBookData()
    register({
      name: 'OverlayAddHistoryBook',
      open: ({ afterClose }) => {
        this.afterClose = afterClose
        this.open()
      },
      close: () => {
        this.close()
      }
    })
  },
  methods: {
    close() {
      this.show = false
      this.$nextTick(() => {
        this.toast && this.toast.clear()
      })

      if (this.afterClose) {
        setTimeout(() => {
          this.afterClose()
        }, 1500)
      }
    },
    open() {
      this.show = true
    },
    lazyImage(cover) {
      return {
        src: cover ? `/cms/upload/cover/p` + cover : '',
        error: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png',
        loading: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png'
      }
    },
    change() {
      if (this.result <= 0) {
        this.noAdd = true
      } else {
        this.noAdd = false
      }
    },
    toJump() {
      setCookie('isJump', true, 30)
      // window.location.href = `/cms/webapp/home/vipHome/#/index`
      this.close()
    },
    toAddBook() {
      if (this.noAdd) {
        return false
      } else {
        if (this.loading) return
        this.loading = true
        // 自定义加载图标
        this.$http
          .post(
            '/cms/weixin/workbook/collect/batchSave',
            getformData({
              openid: this.userInfo.openid,
              wbId: this.result.join(',')
            })
          )
          .then((res) => {
            if (res) {
              // this.$router.push({ path: '/index' })
              // window.location.href = `/cms/webapp/home/vipHome/#/index`
              this.toJump()
              Toast({ duration: 1500, message: '成功加入书架' })
            } else {
              this.loading = false
            }
          }).catch(() => {
            this.loading = false
          })
      }
    },
    // 获取书籍list
    getBookData() {
      this.$http
        .post(
          '/cms/weixin/workbook/collect/checkWbCollectByOpenid',
          getformData({
            openid: this.userInfo.openid
          })
        )
        .then((res) => {
          this.bookData = res.data.data
          if (res.data.data !== '[]') {
            this.result = this.bookData.map((item) => {
              return item[0].toString()
            })
          }
        })
    }

  }
}
</script>

<style lang="scss">
.container {
  width: 100%;
  height: 100%;
  background: #fff;
  header {
    padding-top: 0.12rem;
    .a {
      display: block;
      padding-top: 0.12rem;
      font-size: 0.37rem;
      color: rgba(153, 153, 153, 1);
      text-align: right;
      margin-right: 0.39rem;
    }
  }
  .main {
    padding-top: 0.73rem;
    .headline {
      padding-bottom: 1.15rem;
      padding-left: 0.53rem;
      .headline_top {
        font-size: 0.61rem;
        color: #333333;
        font-weight: 500;
      }
      .headline_bottom {
        font-size: 0.37rem;
        color: #666666;
        margin-top: 0.4rem;
      }
    }
    .contant {
      padding: 0 0.4rem;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .van-checkbox-group {
        width: 100%;
        // min-height: 9.2rem;
        display: flex;
        flex-wrap: wrap;
        .van-checkbox__label {
          margin-left: 0;
        }
      }
      .book {
        width: 2.64rem;
        margin-right: 0.64rem;
        margin-bottom: 0.64rem;
        display: flex;
        align-items: center;
        position: relative;
        &.noright {
          margin-right: 0;
        }

        .van-checkbox__icon {
          width: 0.69rem;
          height: 0.69rem;
          position: absolute;
          z-index: 33;
          right: 0.19rem;
          bottom: 0.19rem;
        }
        .select {
          width: 0.69rem;
          position: absolute;
          z-index: 33;
          right: 0.19rem;
          bottom: 0.19rem;
        }
        img {
          width: 100%;
          border-radius: 0.13rem;
        }
      }
      button {
        width: 9.2rem;
        height: 1.15rem;
        background: linear-gradient(270deg, rgba(239, 66, 70, 1), rgba(255, 139, 62, 1));
        border-radius: 0.57rem;
        font-size: 0.43rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 0.67rem;
        margin-top: 0.2rem;
        &.gray {
          background: rgba(229, 229, 229, 1);
          color: rgba(176, 176, 176, 1);
        }
      }
    }
  }
}
</style>
